var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) {
        if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

import React from "react";
import { Col, Row } from "reactstrap";
import { Title } from "../../components";
import Icon from "../../components/Icon";
import { InformationSectionWrapper, Information, InformationIcon, InformationTitle } from "./InformationSection.styled";

var InformationSection = function InformationSection(_a) {
  var title = _a.title,
      subtitle = _a.subtitle,
      benefits = _a.benefits,
      anchor = _a.anchor,
      props = __rest(_a, ["title", "subtitle", "benefits", "anchor"]);

  return React.createElement(InformationSectionWrapper, __assign({
    id: anchor
  }, props), React.createElement(Row, null, React.createElement(Col, {
    xs: 12
  }, React.createElement(Title, {
    element: "h3"
  }, title), React.createElement("h6", null, subtitle))), React.createElement(Row, null, benefits.map(function (_a) {
    var title = _a.title,
        icon = _a.icon;
    return React.createElement(Information, {
      xs: 12,
      md: 12 / benefits.length
    }, React.createElement(InformationIcon, null, React.createElement(Icon, {
      name: icon,
      color: "white"
    })), React.createElement(InformationTitle, null, title));
  })));
};

export default InformationSection;